/* import __COLOCATED_TEMPLATE__ from './highpass-multiplefeedback.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();